export default __webpack_public_path__ + "static/without_session_repeat_order-3114b0bad853d3faa6db9c13a2509605.png";